module.exports = __webpack_public_path__ + "img/LV6.38e7f50a.webp";